import React from 'react';
import { ArrowRight } from 'lucide-react';
import { PlatformInfo } from '../pages/ProductMatrixNew';

interface PlatformCardProps {
  platform: PlatformInfo;
  isAvailable: boolean;
  platformImage: string;
  platformImageSize: string;
  hardwareIcons: { icon: React.ComponentType<any>, rotate?: boolean }[];
  onClick: () => void;
  theme?: 'light' | 'dark';
}

const PlatformCard: React.FC<PlatformCardProps> = ({
  platform,
  isAvailable,
  platformImage,
  platformImageSize,
  hardwareIcons,
  onClick,
  theme = 'dark'
}) => {
  return (
    <div
      className={`
        relative flex-shrink-0 w-full sm:w-64 bg-white dark:bg-gray-800 rounded-xl p-4
        transition-all duration-300 ease-out cursor-pointer shadow-lg border border-gray-200 dark:border-gray-700
        hover:shadow-xl hover:-translate-y-1 hover:border-blue-400 dark:hover:border-blue-600
        ${isAvailable
          ? ''
          : 'opacity-60 cursor-not-allowed'
        }
      `}
      onClick={onClick}
    >


   
{/* Image Area */}
<div className="w-full h-40 bg-white dark:bg-gray-900 rounded-lg overflow-hidden mb-0 flex items-center justify-center relative">
        <img
          src={`/${platformImage}`}
          alt={platform.name}
          className={`${platformImageSize} object-contain`}
        />
      </div>

         {/* Text Area */}
         <div className="text-center mt-2 mb-4">
        <div className="flex items-center justify-center">
          <h3 className="text-md font-medium text-gray-900 dark:text-gray-100 leading-tight">
            {platform.name}
          </h3>

        </div>
      </div>
      {/* Disabled Overlay */}
      {!isAvailable && (
        <div className="absolute inset-0 bg-white/95 dark:bg-gray-900/95 rounded-xl flex items-center justify-center">
          <div className="text-center">
            <div className="text-base font-medium text-gray-600 dark:text-gray-400 mb-1">
              Currently Not Available
            </div>
            <div className="text-sm text-gray-400 dark:text-gray-500">
              Not available in selected region
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlatformCard;
